import React from 'react'
import { Link } from 'react-router-dom'
import Breadcrumb from './Breadcrumb'
import Logo from "../assets/logo.svg"
import cookie from "../libs/cookie/client";
const Header = props => {
    return (
        <header className="flex w-full py-4 px-10 items-center relative z-50">
            <Link to="/"><img src={Logo} alt="Viewpro" className="h-3.5" /></Link>
           {props.hideBreadcrumb ? "" :  <Breadcrumb />}
            <div className="ml-auto relative flex">
                {cookie.getItem("username")==null &&
                <span className="mr-6"></span>
                }
                 {cookie.getItem("username")!=null &&
                <span className="mr-6 hidden lg:flex">{props.hideSalutation ? '' : "Hi, "+cookie.getItem("username")}</span>
                }
                {props.rightContent}
          
            </div>
        </header>
    )
}


export default Header
